export default function hasLength(value, { minimum }) {
  return value.length >= minimum
}
